export default "__VITE_ASSET__BoEfnju$__"